import React from 'react'
import { Outlet } from 'react-router-dom'
import { Container, SiteLayout } from '@sainsburys-tech/luna-react'

import PageHeader from '../Common/Header'
import HelpdeskBanner from '../Common/HelpdeskBanner'

interface HomePageProps {
  roles: string[]
}

const HomePage = ({ roles }: HomePageProps) => {
  return (
    <SiteLayout stickyHeader className='page'>
      <PageHeader roles={roles} />
      <Container className='helpdesk-banner' fluid size='lg'>
        <HelpdeskBanner/>
      </Container>
      <Container className='content' soft size='lg'>
        <Outlet />
      </Container>
    </SiteLayout>
  )
}

export default HomePage